export default "__VITE_ASSET__DeGupqzO__"